import { SOTT_DEFAULT_SCREENS } from '@24i/nxg-sdk-smartott/src/navigation/constants';
import { TV_SCREENS } from '@24i/nxg-sdk-smartott-tv/src/navigation/constants';
import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics';
import { MapTriggerFunction, TealiumResultPayload } from '../types';

export const mapScreenStrict: MapTriggerFunction = (
    _triggerName,
    payload,
    _dataMapper
): TealiumResultPayload => {
    const screen =
        payload.payload.params?.screen ||
        payload.payload.params?.screenName ||
        payload.payload.screen ||
        payload.payload.pageId;
    const originLabel = payload.payload.params?.origin?.label;
    const asset = payload.payload.params?.asset || payload.payload.asset;
    const screenName = payload.payload.params?.title || payload.payload.params?.screenTitle;

    if (screen === SOTT_DEFAULT_SCREENS.LANDING || screen === TV_SCREENS.LANDING) {
        return {
            section: 'onboarding',
            content_type: 'onboarding',
            subcontent_type: 'welcomeScreen',
            page_name: 'Onboarding',
            page_title: 'Onboarding',
        };
    }
    if (screen === 'home' || screen === SOTT_DEFAULT_SCREENS.HOME || screen === TV_SCREENS.HOME) {
        return {
            section: 'main',
            content_type: 'home',
            subcontent_type: 'home',
            page_name: 'Home',
            page_title: 'Home',
        };
    }
    if (screen === SOTT_DEFAULT_SCREENS.DETAILS || screen === TV_SCREENS.DETAILS) {
        return {
            section: originLabel,
            content_type: 'detail',
            subcontent_type: String(asset.type),
            page_name: originLabel,
            page_title: asset.title || '',
        };
    }
    if (screen === SOTT_DEFAULT_SCREENS.PLAYBACK || screen === TV_SCREENS.PLAYBACK) {
        return {
            section: originLabel,
            content_type: 'video',
            subcontent_type: asset.type,
            page_name: originLabel,
            page_title: asset.title || '',
        };
    }
    return {
        section: originLabel,
        content_type: originLabel,
        subcontent_type: screen,
        page_name: screenName,
        page_title: screenName,
    };
};

let previousResult: TealiumResultPayload | undefined;

export const mapScreen: MapTriggerFunction = (
    triggerName,
    payload,
    dataMapper
): TealiumResultPayload => {
    const strict = mapScreenStrict(triggerName, payload, dataMapper);
    const isFilled = strict.content_type || strict.page_name || strict.subcontent_type;
    if (triggerName === ANALYTICS_TRIGGERS.SCENE_VIEW || isFilled) {
        previousResult = strict;
        return strict;
    }
    if (previousResult) return previousResult;
    return {
        section: '',
        content_type: '',
        subcontent_type: '',
        page_name: undefined,
        page_title: undefined,
    };
};
